export default __webpack_public_path__ + "static/media/effort.db801491.svg";